<template>
    <div>
      <NavbarOne/>
  
      <div
        class="flex items-center gap-4 flex-wrap bg-overlay p-14 sm:p-16 before:bg-title before:bg-opacity-70"
        :style="{ backgroundImage: 'url(' + bg + ')' }"
      >
        <div class="text-center w-full">
          <h2 class="text-white text-8 md:text-[40px] font-normal leading-none text-center">
            Productos
          </h2>
  
          <ul class="flex items-center justify-center gap-[10px] text-base md:text-lg leading-none font-normal text-white mt-3 md:mt-4">
            <li><router-link to="/">Inicio</router-link></li>
            <li>/</li>
            <li class="text-primary">Productos</li>
          </ul>
        </div>
      </div>
  
      <div class="s-py-100">
        <div class="container-fluid">
          <div class="max-w-[1720px] mx-auto pt-8 md:pt-[50px]">
  
            <!-- ✅ Filtro SOLO si es Ropa -->
            <div v-if="isRopa" class="mb-6 flex items-center gap-3 flex-wrap">
              <label class="text-base font-medium">Mercancía:</label>
  
              <select
                v-model="selectedGender"
                class="border rounded px-3 py-2"
              >
                <option value="">Toda</option>
                <option value="Femenino">De mujer</option>
                <option value="Masculino">De hombre</option>
              </select>
            </div>
  
            <div data-aos="fade-up" data-aos-delay="200">
              <ProductsLayout
                :classList="'grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5 sm:gap-8'"
                :productList="filteredProducts"
              />
            </div>
  
          </div>
        </div>
      </div>
  
      <FooterOne/>
      <ScrollToTop/>
    </div>
  </template>
  
  <script setup>
  import { onMounted, ref, computed, watch } from "vue";
  import { useRoute } from "vue-router";
  
  import NavbarOne from "@/components/navbar/navbar-one.vue";
  import FooterOne from "@/components/footer/footer-one.vue";
  import ScrollToTop from "@/components/scroll-to-top.vue";
  import ProductsLayout from "@/components/product/products-layout.vue";
  import bg from "@/assets/img/shortcode/breadcumb.jpg";
  
  import Aos from "aos";
  
  const route = useRoute();
  const products = ref([]);
  const selectedGender = ref(""); // "" = todos
  const encodedCategory = encodeURIComponent(route.params.name);
  const apiUrl = process.env.VUE_APP_API_URL || 'http://localhost:8080'
  
  // ✅ Detecta si la categoría es "Ropa"
  const isRopa = computed(() => {
    const name = String(route.params.name || "");
    return name.toLowerCase() === "ropa";
  });
  
  // ✅ Lista filtrada (solo filtra género si es Ropa y si eligieron género)
  const filteredProducts = computed(() => {
    if (!isRopa.value) return products.value;
  
    if (!selectedGender.value) return products.value;
  
    const target = selectedGender.value.toLowerCase();
  
    return products.value.filter((p) => {
      // Cambia aquí si tu API usa otro nombre de propiedad
      const gender =
        (p.gender ?? p.genero ?? p.genre ?? "").toString().toLowerCase();
  
      return gender === target;
    });
  });
  
  const getProducts = async () => {
        try{
            const result = await fetch(`${apiUrl}/products/categories/name?category=${encodedCategory}`);
            if(!result.ok){
                throw new Error(`Error HTTP: ${result.status}`);
            }
            const data = await result.json();
            console.log(data);
            
            products.value = Array.isArray(data) ? data : [];
        }catch (error){
            console.log(error);
        }
    }
  
  onMounted(() => {
    Aos.init();
    getProducts();
  });
  
  // ✅ Si cambia la ruta (/categorias/:name), recargar productos y resetear género
  watch(
    () => route.params.name,
    () => {
      selectedGender.value = "";
      getProducts();
    }
  );
  
  // ✅ Si dejan de estar en Ropa, limpia género
  watch(isRopa, (val) => {
    if (!val) selectedGender.value = "";
  });
  </script>